<template>
  <div class="content"></div>
</template>

<script>
export default {
  created() {
    const toast = this.$createToast({
      txt: "Loading...",
      mask: true,
      time: 10000
    });
    toast.show();

    let target = this.$route.params.target;
    let id = this.$route.params.id;

    let toUrl = "";
    if (id == -1) {
      toUrl =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa5520eff0ecff405&redirect_uri=http%3A%2F%2Fwx.aixyt.com%2Fapi%2Fwx%2Fauth&response_type=code&scope=snsapi_userinfo&state=" + target + "#wechat_redirect";
    } else {
      toUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa5520eff0ecff405&redirect_uri=http%3A%2F%2Fwx.aixyt.com%2Fapi%2Fwx%2Fauth&response_type=code&scope=snsapi_userinfo&state=" + target + "-" + id + "#wechat_redirect";
    }

    window.location.href = toUrl;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/Share.vue